import { createModule } from '@vue-storefront/core/lib/module'
// TODO: Move the logic to appropriate modules and deprecate this one
import config from "config";

const KEY = 'ui'
const store = {
  namespaced: true,
  state: {
    sidebar: false,
    bannerData: new Date(config.bannersData.date).toLocaleString('en-US', {timeZone: 'Europe/Kiev'}),
    microcart: false,
    wishlist: false,
    searchpanel: false,
    newsletterPopup: false,
    overlay: false,
    loader: false,
    authElem: 'login',
    checkoutMode: false,
    openMyAccount: false,
    partnerPage: false,
    preloader:false,
    submenu: {
      depth: false,
      path: []
    },
    cartSkeleton: false,
    device: ''
  },
  getters : {
    getLoader: (state) => state.preloader,
    getBannerStatus (state) {
      let nowDate = new Date().toLocaleString('en-US', {timeZone: 'Europe/Kiev'})
      if (new Date(state.bannerData).getDate() === new Date(nowDate).getDate() &&
        new Date(state.bannerData).getFullYear() === new Date(nowDate).getFullYear() &&
        new Date(state.bannerData).getMonth() === new Date(nowDate).getMonth()) {
        return true
      }
      return false
    },
    getCartSkeleton: (state) => state.cartSkeleton,
    getDevice: (state) => state.device
  },
  mutations: {
    setCheckoutMode (state, action) {
      state.checkoutMode = action === true
    },
    setMicrocart (state, action) {
      state.microcart = action === true
      state.overlay = action === true
    },
    setSidebar (state, action) {
      state.sidebar = action === true
      state.overlay = action === true
    },
    setSubmenu (state, { id, depth }) {
      if (id) {
        state.submenu.path.push(id)
      } else if (state.submenu.path.length) {
        setTimeout(() => {
          state.submenu.path.pop()
        }, 300)
      }
      state.submenu.depth = state.submenu.depth > 0 && depth
    },
    setSearchpanel (state, action) {
      state.searchpanel = action === true
      state.overlay = action === true
    },
    setWishlist (state, action) {
      state.wishlist = action === true
      state.overlay = action === true
    },
    setOverlay (state, action) {
      state.overlay = action === true
    },
    setLoader (state, action) {
      state.loader = action === true
    },
    setAuthElem (state, action) {
      state.authElem = action
    },
    setPartnerPage(state, action) {
      state.partnerPage = action;
    },
    OnAndOffLoader(state,statusLoader){
      state.preloader = statusLoader;
    },
    toggleCartSkeleton (state, value) {
      state.cartSkeleton = value
    },
    setDevice (state, device) {
      state.device = device
    }
  },
  actions: {
    toggleMicrocart ({ commit, state }) {
      commit('setMicrocart', !state.microcart)
    },
    toggleWishlist ({ commit, state }) {
      commit('setWishlist', !state.wishlist)
    },
    togglePartnerPage ({ commit, state }) {
      commit('setPartnerPage', !state.partnerPage)
    },
    OnAndOffLoader ({ commit }, statusLoader){
      commit('OnAndOffLoader', statusLoader)
    },
    toggleCartSkeleton ({ commit }, value) {
      commit('toggleCartSkeleton', value)
    },
    setDevice ({ commit }, device) {
      commit('setDevice', device)
    }
  }
}

export const Ui = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module: store }] }
})
